// Hook para contar registros pendentes de envio (Dexie + dexie-react-hooks).

import { useLiveQuery } from 'dexie-react-hooks';
import { localDb } from './db';

export function usePendentesCount(): number {
  const count = useLiveQuery(() => localDb.pontos_pendentes.count(), [], 0);
  return count ?? 0;
}

export default usePendentesCount;
